import React from 'react'
import {
  TX_STATUS_COMPLETED,
  TX_STATUS_CUSTOMER_REVIEW,
  TX_STATUS_FAILED,
  TX_STATUS_HOLD,
  TX_STATUS_NEW,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_PROCESSING,
  TX_STATUS_RESTARTED,
} from '../config'
import { holdReasonLabel, transactionStateLabel } from '../utils/display_names'

const STATE_BADGE_CLASSES = {
  [TX_STATUS_NEW]: 'label-success',
  [TX_STATUS_PROCESSING]: 'label-information',
  [TX_STATUS_COMPLETED]: 'label-primary',
  [TX_STATUS_FAILED]: 'label-danger',
  [TX_STATUS_HOLD]: 'label-warning',
  [TX_STATUS_RESTARTED]: 'label-success',
  [TX_STATUS_POST_PROCESSING]: 'label-success',
  [TX_STATUS_CUSTOMER_REVIEW]: 'label-success',
}

// `holdReason` is the server-computed enum; it is only meaningful when the
// state is hold, and null there means a hold we do not classify.
const StatusLabel = ({ state, holdReason }) => {
  const badgeClass = Object.prototype.hasOwnProperty.call(STATE_BADGE_CLASSES, state)
    ? STATE_BADGE_CLASSES[state]
    : null

  if (!badgeClass) {
    return <span />
  }

  const text = state === TX_STATUS_HOLD ? holdReasonLabel(holdReason) : transactionStateLabel(state)

  return <span className={`label ${badgeClass} text-uppercase`}>{text}</span>
}

export default StatusLabel
